import React from "react";
import "../styles/StatusBar.css";

const StatusBar = ({ currentStep }) => {
  const steps = [
    "Select Location",
    "Select Sector",
    "Select Dataset",
    "Select Topics",
    "Select Ethnicity",
  ];

  return (
    <div className="status-bar">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`step ${index < currentStep ? "completed" : ""} ${
            index === currentStep ? "current" : ""
          }`}
        >
          {index < currentStep ? (
            <div className="tick-circle">
              <span className="tick">✓</span>
            </div>
          ) : (
            <span
              className={`step-number ${index > currentStep ? "future" : ""}`}
            >
              {index + 1}
            </span>
          )}
          <span
            className={`step-text ${
              index === currentStep ? "current-text" : ""
            } ${index < currentStep ? "completed-text" : ""} ${
              index > currentStep ? "future-text" : ""
            }`}
          >
            {step}
          </span>
          {index < steps.length - 1 && <span className="arrow">→</span>}
        </div>
      ))}
    </div>
  );
};

export default StatusBar;
